import React from "react";
import { Link } from "react-router-dom";
import { Section } from "./SeoUI";
import { faqs } from "../data/seoData";
import { ReactComponent as DropdownIcon } from "./../assets/svgs/dropdown-icon.svg";

const FAQSection = () => {
  const [openFaq, setOpenFaq] = React.useState(0);
  return (
    <Section id="faq" className="bg-[#f7f7f7] pt-0">
      <div className="mx-auto max-w-[1152px] rounded-xl bg-white p-6 sm:p-10">
        <h2 className="text-[16px] md:text-xl font-medium text-[#1A1A1A] font-inter">
          Frequently Asked Questions
        </h2>
        <p className="mt-1 text-xs md:text-[13px] font-spaceMono text-[#BBBBBB]">
          Everything about Reformation
        </p>
        <div className="mt-8 divide-y divide-neutral-200">
          {faqs.map((faq, i) => (
            <div key={faq.q}>
              <button
                type="button"
                aria-expanded={openFaq === i}
                aria-controls={`eveness-answer-${i}`}
                onClick={() => setOpenFaq(openFaq === i ? -1 : i)}
                className="flex w-full items-center gap-4 py-5 text-left"
              >
                <span className="font-spaceMono text-[10px] md:text-[11px] text-[#BBBBBB]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="flex-1 text-sm md:text-[15px] font-medium font-inter">
                  {faq.q}
                </span>
                <span aria-hidden="true" className="text-[#BBBBBB]">
                  <DropdownIcon
                    className={`mb-1 transition-transform duration-200
                      ${openFaq === i ? "rotate-180" : ""}
                    `}
                  />
                </span>
              </button>
              {openFaq === i && (
                <p
                  id={`eveness-answer-${i}`}
                  className="pb-5 pl-8 pr-6 text-[13px] md:text-[14px] leading-7 text-[#555555] font-inter"
                >
                  {faq.a}
                </p>
              )}
            </div>
          ))}
        </div>
        <div className="mt-2 border-t pt-5 text-xs md:text-[13px] font-inter text-[#999999]">
          Still have questions?{" "}
          <Link
            to="/contact-us"
            className="ml-2 text-[#1A1A1A] underline underline-offset-4 font-spaceMono text-[12px] md:text-[13px]"
          >
            Visit thereformation.com
          </Link>
        </div>
      </div>
    </Section>
  );
};

export default FAQSection;
